<template>
  <div class="w-100 d-flex align-content-center justify-content-center ">
    <input v-for="(digit, idx) in code" :key="idx" type="text" class="form-control mx-1 text-center" maxlength="1"
      pattern="[0-9]*" inputmode="numeric" :value="digit" @input="onInput($event, idx)"
      @keydown="onKeyDown($event, idx)" @paste="onPaste($event, idx)" ref="inputs" style="width: 50px;" autocomplete="off" :disabled="disabled" />
  </div>
</template>

<script>
export default {
  name: "BaseAccessCodeInput",
  props: {
    length: {
      type: Number,
      default: 6
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      code: Array(this.length).fill("")
    };
  },
  mounted() {
    // Focar no primeiro input quando o componente for montado
    this.$nextTick(() => {
      if (this.$refs.inputs && this.$refs.inputs[0]) {
        this.$refs.inputs[0].focus();
      }
    });
  },
  methods: {
    onInput(e, idx) {
      const digits = e.target.value.replace(/\D/g, "");

      if (digits.length > 1) {
        this.applyDigitsFromIndex(digits, idx);
        return;
      }

      let val = digits;
      if (!val) {
        this.$set(this.code, idx, "");
        this.$emit("inputCode", this.code.join(""));
        return;
      }
      this.$set(this.code, idx, val[0]);

      if (idx < this.length - 1) {
        this.$refs.inputs[idx + 1].focus();
      }

      this.$emit("inputCode", this.code.join(""));
    },
    applyDigitsFromIndex(digits, startIdx) {
      const chars = digits.slice(0, this.length - startIdx).split("");
      chars.forEach((char, offset) => {
        this.$set(this.code, startIdx + offset, char);
      });
      const nextIdx = Math.min(startIdx + chars.length, this.length - 1);
      this.$nextTick(() => {
        if (this.$refs.inputs && this.$refs.inputs[nextIdx]) {
          this.$refs.inputs[nextIdx].focus();
        }
        this.$emit("inputCode", this.code.join(""));
      });
    },
    onPaste(e, idx) {
      e.preventDefault();
      const pasted = (e.clipboardData || window.clipboardData)
        .getData("text")
        .replace(/\D/g, "");
      if (!pasted) return;
      this.applyDigitsFromIndex(pasted, idx);
    },
    onKeyDown(e, idx) {
      if (e.key === "Backspace") {
        if (this.code[idx] === "") {
          if (idx > 0) {
            this.$refs.inputs[idx - 1].focus();
          }
        } else {
          this.$set(this.code, idx, "");
          this.$emit("inputCode", this.code.join(""));
        }
      } else if (e.key === "ArrowLeft" && idx > 0) {
        this.$refs.inputs[idx - 1].focus();
      } else if (e.key === "ArrowRight" && idx < this.length - 1) {
        this.$refs.inputs[idx + 1].focus();
      }
    }
  }
};
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="text"] {
  font-size: 2.2rem;
  height: 55px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.1);
  color: var(--lp-text-on-dark);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

input[type="text"]:focus {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(138, 43, 226, 0.6);
  box-shadow: 0 0 0 3px rgba(138, 43, 226, 0.2);
  outline: none;
}

input[type="text"]:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>